// Module
var code = "<div class=\"qrCode\"> <div class=\"qrCode_instructions\"> <h3 class=\"qrCode_headline\">{{ t('offlineInstructions_qrCodeHeadline') }}</h3> <p class=\"qrCode_info\">{{ t('offlineInstructions_qrCodeInfo') }}</p> </div> <canvas ref=\"qrCode\" class=\"qrCode_canvas t-qrCode_canvas\"></canvas> </div> ";
// Exports
export default code;